import { Cell } from './Cell'
import { MAX_GUESS_LENGTH } from '../../constants/guessLength'

export const EmptyRow = () => {
  const emptyCells = Array.from(Array(MAX_GUESS_LENGTH))

  return (
    <div className="flex justify-center mb-1">
      {emptyCells.map((_, i) => (
        <Cell key={i} />
      ))}
    </div>
  )
}
